export default __webpack_public_path__ + "static/media/realizations.c4622866.webp";